const isProd = import.meta.env.PROD;

export function track(event: string, properties?: Record<string, unknown>): void {
  if (!isProd) {
    console.log('[WedTrack]', event, properties ?? '');
    return;
  }
  // Fire-and-forget — never await, never throw
  fetch('/api/analytics/track', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ event, properties, ts: Date.now() }),
  }).catch(() => {});
}
